import { AppSpacer } from 'components/ui';
import { Switch } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';

type AppSwitchProps = {
  isChecked: boolean;
  onChange: (e) => void;
  name?: string;
  title?: string;
  appendToTitleSlot?: React.ReactNode;
  desc?: string;
  isDisabled?: boolean;
  isReversed?: boolean;
  isWithoutBorder?: boolean;
  width?: string;
  hint?: string;
  isEdited?: boolean;
  hideValue?: boolean;
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error' | undefined;
  classNames?: string;
};

const AppSwitch = ({
  name = 'appSwitch',
  title = '',
  desc = '',
  isDisabled = false,
  isReversed = true,
  isWithoutBorder = true,
  width = '130',
  isChecked,
  onChange,
  hint = '',
  appendToTitleSlot,
  isEdited = false,
  hideValue = false,
  classNames = '',
  color = 'default',
}: AppSwitchProps) => {
  const { t } = useTranslation();
  return (
    <>
      <section className={`app-switch d-flex align-items-start ${classNames}`}>
        {!hideValue && (title || desc) && (
          <>
            <div>
              {title && (
                <h3 className='font-15 font-700 font-lato mb-0 color-black'>
                  {title} {appendToTitleSlot}
                  {isEdited ? <span className={`text-nowrap custom_chip_outlined custom_chip_outlined--blue`}>{t('edited')}</span> : null}
                </h3>
              )}

              {desc && (
                <>
                  <p className='font-15 font-400 mb-0 color-black '>
                    <span>{desc}</span>
                  </p>
                  <AppSpacer space='16px' />
                </>
              )}
            </div>
            <AppSpacer space='25px' isHorizontal />
          </>
        )}

        <div className='d-flex'>
          <Switch
            className='text-capitalize'
            label={hideValue ? title : isChecked ? t('enabled') || 'Enabled' : t('disabled') || 'Disabled'}
            width={width}
            withoutBorder={isWithoutBorder}
            reversed={isReversed}
            checked={isChecked}
            disabled={isDisabled}
            hint={hint}
            name={name}
            onChange={(e) => onChange(e)}
            color={color}
            sx={{
              '& .Mui-checked + .MuiSwitch-track': {
                backgroundColor: `${color} !important`,
                border: `1px solid ${color} !important`,
              },
            }}
          />
        </div>
      </section>
    </>
  );
};

export default AppSwitch;
